module.exports = __webpack_public_path__ + "img/desjardins_carrefour.9eb3d6a6.webp";